import { render, staticRenderFns } from "./HcDropdownMenu.vue?vue&type=template&id=2896e83e&scoped=true&"
import script from "./HcDropdownMenu.vue?vue&type=script&lang=js&"
export * from "./HcDropdownMenu.vue?vue&type=script&lang=js&"
import style0 from "./HcDropdownMenu.vue?vue&type=style&index=0&id=2896e83e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.0_enyi6aqizbgycdmugvkasw26ru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2896e83e",
  null
  
)

export default component.exports